module.exports = __webpack_public_path__ + "img/logo_dear_mama.ac583f28.png";